var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#FED530"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 18.1667V14.8333C14.8333 13.7283 15.2723 12.6684 16.0537 11.887C16.8351 11.1056 17.8949 10.6667 19 10.6667C20.1051 10.6667 21.1649 11.1056 21.9463 11.887C22.7277 12.6684 23.1667 13.7283 23.1667 14.8333V18.1667M13.1667 18.1667H24.8333C25.7538 18.1667 26.5 18.9128 26.5 19.8333V25.6667C26.5 26.5871 25.7538 27.3333 24.8333 27.3333H13.1667C12.2462 27.3333 11.5 26.5871 11.5 25.6667V19.8333C11.5 18.9128 12.2462 18.1667 13.1667 18.1667Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.6631b0b5e5e33992f17d5eff8408def3.svg";
export { ForwardRef as ReactComponent };